import { render } from "./FormLegend.vue?vue&type=template&id=416c23f2&scoped=true"
import script from "./FormLegend.vue?vue&type=script&lang=js"
export * from "./FormLegend.vue?vue&type=script&lang=js"

import "./FormLegend.vue?vue&type=style&index=0&id=416c23f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-416c23f2"]])

export default __exports__